import { Pipe, PipeTransform } from '@angular/core';

import { USDT_SYMBOLS } from '@kr/models';

@Pipe({
  name: 'hintCurrencyFormat',
  standalone: true,
})
export class HintCurrencyFormatPipe implements PipeTransform {
  transform(value: string, currency = 'BTC'): string {
    if (!value) return value;

    let [integer, decimal = ''] = value.split('.');
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (currency === 'BTC') {
      decimal = decimal.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    } else if ([...USDT_SYMBOLS, 'TRX'].includes(currency)) {
      decimal = decimal.substring(0, 3);
    }

    return `${integer}.${decimal}`;
  }
}
